// Reserved keywords not allowed to use in the parser
export var keywords = new Set(['end']);


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/expression/keywords.js
// module id = 579
// module chunks = 2